import { render, staticRenderFns } from "./SearchTabsOld.vue?vue&type=template&id=127e7a3d&"
import script from "./SearchTabsOld.vue?vue&type=script&lang=js&"
export * from "./SearchTabsOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports